var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3418 24.6168C8.05013 24.3251 7.9043 23.9797 7.9043 23.5807C7.9043 23.1825 8.05013 22.8376 8.3418 22.5459L16.8876 14.0001L8.31263 5.42508C8.04041 5.15286 7.9043 4.81258 7.9043 4.40425C7.9043 3.99591 8.05013 3.64591 8.3418 3.35425C8.63346 3.06258 8.9788 2.91675 9.3778 2.91675C9.77602 2.91675 10.121 3.06258 10.4126 3.35425L20.2126 13.1834C20.3293 13.3001 20.4121 13.4265 20.4611 13.5626C20.5094 13.6987 20.5335 13.8445 20.5335 14.0001C20.5335 14.1556 20.5094 14.3015 20.4611 14.4376C20.4121 14.5737 20.3293 14.7001 20.2126 14.8167L10.3835 24.6459C10.1112 24.9181 9.77602 25.0543 9.3778 25.0543C8.9788 25.0543 8.63346 24.9084 8.3418 24.6168Z",
    fill: "url(#paint0_linear_391_694)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_391_694",
    x1: 7.9043,
    y1: 13.9855,
    x2: 20.5335,
    y2: 13.9855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.1e0d54f6f5e5ff2a616246eacd25e188.svg";
export { ForwardRef as ReactComponent };